module.exports = __webpack_public_path__ + "img/update-2.26d7ec08.svg";